import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-disguise-bid-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './disguise-bid-confirmation-modal.component.html',
  styleUrls: ['./disguise-bid-confirmation-modal.component.scss']
})
export class DisguiseBidConfirmationModalComponent {
  @Input() isActive: boolean = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
